/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { LoadListSync01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const loadListSync01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const loadListSync01FetchLoadListSync01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const loadListSync01FetchLoadListSync01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const loadListSync01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const loadListSync01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const loadListSync01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const loadListSync01SyncLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

export const loadListSync01SyncNowSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [LoadListSync01Types.LOAD_LIST_SYNC01_RESET_TIMESTAMP]: loadListSync01ResetTimestamp,
  [LoadListSync01Types.LOAD_LIST_SYNC01_FETCH_LOAD_LIST_SYNC01_LOADING]: loadListSync01FetchLoadListSync01Loading,
  [LoadListSync01Types.LOAD_LIST_SYNC01_FETCH_LOAD_LIST_SYNC01_SUCCESS]: loadListSync01FetchLoadListSync01Success,
  [LoadListSync01Types.LOAD_LIST_SYNC01_ADD_SELECTED_DOCUMENTS]: loadListSync01AddSelectedDocuments,
  [LoadListSync01Types.LOAD_LIST_SYNC01_REMOVE_SELECTED_DOCUMENTS]: loadListSync01RemoveSelectedDocuments,
  [LoadListSync01Types.LOAD_LIST_SYNC01_SET_WORKSPACE_VISIBLE]: loadListSync01SetWorkspaceVisible,
  [LoadListSync01Types.LOAD_LIST_SYNC01_SYNC_LOADING]: loadListSync01SyncLoading,
  [LoadListSync01Types.LOAD_LIST_SYNC01_SYNC_NOW_SUCCESS]: loadListSync01SyncNowSuccess
});
